var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.773,
    height: 15.669,
    viewBox: "0 0 11.773 15.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clipboard",
    transform: "translate(-0.45 0.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33797",
    "data-name": "Path 33797",
    d: "M10.714,1.947H9.255V1.46A.486.486,0,0,0,8.769.974H7.713a1.459,1.459,0,0,0-2.752,0H3.9a.486.486,0,0,0-.486.486v.486H1.959A1.459,1.459,0,0,0,.5,3.406v10.7a1.459,1.459,0,0,0,1.459,1.459h8.755a1.459,1.459,0,0,0,1.459-1.459V3.406a1.459,1.459,0,0,0-1.459-1.459Zm-6.323,0h.973A.486.486,0,0,0,5.85,1.46a.486.486,0,1,1,.973,0,.486.486,0,0,0,.486.486h.973v.973H4.391ZM11.2,14.106a.486.486,0,0,1-.486.486H1.959a.486.486,0,0,1-.486-.486V3.406a.486.486,0,0,1,.486-.486H3.418v.486a.486.486,0,0,0,.486.486H8.769a.486.486,0,0,0,.486-.486V2.919h1.459a.486.486,0,0,1,.486.486Zm0,0",
    fill: "#dfdfdf",
    stroke: "#dfdfdf",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33798",
    "data-name": "Path 33798",
    d: "M86.358,192.023H80.944a.544.544,0,0,0,0,1.071h5.414a.544.544,0,0,0,0-1.071Zm0,0",
    transform: "translate(-77.315 -186.225)",
    fill: "#dfdfdf",
    stroke: "#dfdfdf",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33799",
    "data-name": "Path 33799",
    d: "M86.358,288.016H80.944a.544.544,0,0,0,0,1.071h5.414a.544.544,0,0,0,0-1.071Zm0,0",
    transform: "translate(-77.315 -279.319)",
    fill: "#dfdfdf",
    stroke: "#dfdfdf",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33800",
    "data-name": "Path 33800",
    d: "M86.358,384.012H80.944a.544.544,0,0,0,0,1.071h5.414a.544.544,0,0,0,0-1.071Zm0,0",
    transform: "translate(-77.315 -372.417)",
    fill: "#dfdfdf",
    stroke: "#dfdfdf",
    strokeWidth: 0.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.79179e279e1d371ef0f04eb7bb166a2f.svg";
export { ForwardRef as ReactComponent };